import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';

import { environment } from '../../../environments/environment';
import { AuthApi } from '../api/auth.api';

/**
 * Attaches the Identity Platform ID token as `Authorization: Bearer <jwt>` to
 * backend API calls. The token is fetched fresh from the SDK (auto-refreshed)
 * rather than read from a cached value.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Only attach credentials to our own backend, never to third parties.
  if (!req.url.startsWith(environment.apiBaseUrl)) {
    return next(req);
  }

  const api = inject(AuthApi);
  return from(api.getIdToken()).pipe(
    switchMap((token) =>
      next(
        token
          ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
          : req,
      ),
    ),
  );
};
